module.exports = __webpack_public_path__ + "img/ballantines-form-bg.303824cd.jpg";